class Breadcrumb {
  name: string;
  label: ((route: any) => Promise<string>);
  params?: ((route: any) => Promise<any>);

  constructor(
    name: string,
    label: ((route: any) => Promise<string>),
    params?: ((route: any) => Promise<any>),
  ) {
    this.name = name;
    this.label = label;
    this.params = params;
  }
}

export { Breadcrumb }